import { useT } from '@kmgestao/i18n';

/**
 * Spinner full-page usado pelos guards de rota enquanto a sessão é verificada.
 * Minimalista para não competir com a marca — fica em `bg-background` e
 * respeita o tema corrente via tokens.
 */
export function FullPageSpinner({ label }: { label?: string }) {
  const { t } = useT('common');
  const resolvedLabel = label ?? t('status.loading');
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh items-center justify-center bg-background text-muted-foreground"
    >
      <div className="flex flex-col items-center gap-3">
        <svg
          className="size-8 animate-spin text-primary"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
        <span className="sr-only">{resolvedLabel}</span>
      </div>
    </div>
  );
}
